import { Component, DestroyRef, EventEmitter, Output, computed, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { CrmConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { TimerService } from '@frontend/sports/common/core/utils/timer';
import { EpcotConfigService, EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';
import { RewardTokenType } from 'packages/sports/web/app/src/tokens-base/token-base.models';
import { take } from 'rxjs';

import { AcquisitionContextType, IRewardToken } from '../../reward-tokens.model';
import { AcquisitionRewardTokenService } from '../../services/acquisition-reward-token.service';

interface IAcquisitionViewData {
    title?: string;
    icon?: string;
    content?: string;
}

@Component({
    standalone: true,
    selector: 'bs-acquisition-reward-notification',
    templateUrl: './acquisition-reward-notification.component.html',
    styleUrls: ['./acquisition-reward-notification.component.scss'],
})
export class AcquisitionRewardNotificationComponent {
    acquisitionRewardToken = input.required<IRewardToken>();
    @Output() hideAcquisitionNotification = new EventEmitter();

    readonly acquisitionViewData = computed(() => this.getAcquisitionViewData(this.acquisitionRewardToken().rewardTokenType));

    private readonly destroyRef = inject(DestroyRef);
    private isEpcotEnabled = this.epcotConfigService.isEnabled(EpcotModule.Rewards);

    constructor(
        private timerService: TimerService,
        private acquisitionRewardTokenService: AcquisitionRewardTokenService,
        private sitecore: Sitecore,
        private tokensConfig: CrmConfig,
        private epcotConfigService: EpcotConfigService,
    ) {
        this.timerService
            .timer(this.tokensConfig.tokens.acquisitionRewardDetails.bannerTooltipDuration)
            .pipe(take(1), takeUntilDestroyed(this.destroyRef))
            .subscribe(() => this.hideAcquisition());
        this.acquisitionRewardTokenService.storeAcquisitionRewardNotification(AcquisitionContextType.BannerTooltip);
    }

    hideAcquisition(): void {
        this.hideAcquisitionNotification.emit();
    }

    private getAcquisitionViewData(rewardTokenType: RewardTokenType): IAcquisitionViewData {
        const title = this.isEpcotEnabled ? '' : this.sitecore.crmTokens.messages.WelcomeOfferTitle;
        const icon = this.isEpcotEnabled ? '' : this.acquisitionRewardTokenService.getTokenIcon(rewardTokenType);
        const content = this.sitecore.crmTokens.banner.BannerWelcomeOffer;

        return <IAcquisitionViewData>{
            title,
            icon,
            content,
        };
    }
}
